var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutPot3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 152,
    viewBox: "0 0 342 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.81 4.01353C169.68 8.88348 168.743 17.7472 168.743 17.7472C168.743 17.7472 159.879 18.7049 155.009 13.8349C150.139 8.965 151.097 0.101237 151.097 0.101237C151.097 0.101237 159.96 -0.856405 164.83 4.03392L164.81 4.01353Z",
    fill: "#51B89F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.511 19.2564C181.641 24.1263 172.777 23.1891 172.777 23.1891C172.777 23.1891 171.84 14.3253 176.71 9.45534C181.579 4.58539 190.443 5.54312 190.443 5.54312C190.443 5.54312 191.401 14.4068 186.531 19.2768L186.511 19.2564Z",
    fill: "#79E6CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.695 40.061C172.695 41.141 171.819 41.9967 170.76 41.9967C169.7 41.9967 168.824 41.1206 168.824 40.061V1.9572C168.824 0.877254 169.7 0.0214844 170.76 0.0214844C171.819 0.0214844 172.695 0.897631 172.695 1.9572V40.061Z",
    fill: "#51B89F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.076 0.078125C151.076 0.078125 150.119 8.94182 154.989 13.8118C159.859 18.6817 168.722 17.724 168.722 17.724L151.056 0.078125H151.076Z",
    fill: "#79E6CB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190.423 5.52344L172.757 23.1898C172.757 23.1898 181.62 24.1474 186.49 19.2571C191.36 14.3871 190.403 5.52344 190.403 5.52344H190.423Z",
    fill: "#51B89F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168.824 1.95611V40.0599C168.824 41.1399 169.7 41.9957 170.76 41.9957V0C169.7 0 168.824 0.876146 168.824 1.93572V1.95611Z",
    fill: "#79E6CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.345 111.64H140.27L135.832 53.7461H205.783L201.345 111.64Z",
    fill: "#FF9A7E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M201.345 111.64H140.27L135.832 53.7461H205.783L201.345 111.64Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.652 64.4306H204.962L205.783 53.7461H135.832L136.652 64.4306Z",
    fill: "#FF9A7E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.652 64.4306H204.962L205.783 53.7461H135.832L136.652 64.4306Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M213.001 40.3652H128.999V54.4325H213.001V40.3652Z",
    fill: "#FF9A7E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M213.001 40.3652H128.999V54.4325H213.001V40.3652Z",
    fill: "white",
    fillOpacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 40,
    transform: "translate(0 111.641)",
    fill: "#9DC5C3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutPot3);
export default __webpack_public_path__ + "static/media/about_pot_3.a5727b0ec4ba475393200bbe538a8092.svg";
export { ForwardRef as ReactComponent };